








import Vue from "vue";
import { getDocumentationBaseUrl,getSignedCookieBaseUrl } from "@/utils/getUser";
// import VueSimpleMarkdown from "vue-simple-markdown";
import "vue-simple-markdown/dist/vue-simple-markdown.css";
import CookieService from "@/services/cookieService";
// import document from "./documents-test/ssh-tunnel-via-ssm.md";

export default Vue.extend({
  name: "Documentation",
  props: ["id"],

  data() {
    return {
      url: "",
      source: ""
    };
  },
  async created() {
    const baseUrl = getDocumentationBaseUrl();
    const signedCookie = getSignedCookieBaseUrl();

    console.log("baseUrl: " + baseUrl);

    if (!this.$props.id) {
      // this.url = "foo.html";
      this.url = baseUrl;
    } else {
      // this.url = `${baseUrl}/${this.$props.id}${signedCookie}`;
      this.url = `${baseUrl}/${this.$props.id}`;
    }
  }
});
